var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "balance_row"
  }, [_vm.asset.symbol ? _c('p', {
    staticClass: "symbol"
  }, [_vm._v(_vm._s(_vm.asset.symbol))]) : _c('p', {
    staticClass: "no_symbol"
  }), _c('router-link', {
    staticClass: "name_id",
    attrs: {
      "to": "/asset/".concat(_vm.asset.id)
    }
  }, [_vm._v(_vm._s(_vm._f("nameOrID")(_vm.asset)))]), _c('p', {
    staticClass: "balance"
  }, [_vm._v(" " + _vm._s(_vm.asset.balance.toLocaleString(_vm.asset.denomination)) + " "), _c('span', [_vm._v(_vm._s(_vm.asset.symbol))])]), _c('p', {
    staticClass: "sent"
  }, [_vm._v(" " + _vm._s(_vm.asset.totalSent.toLocaleString(_vm.asset.denomination)) + " "), _c('span', [_vm._v(_vm._s(_vm.asset.symbol))])]), _c('p', {
    staticClass: "received"
  }, [_vm._v(" " + _vm._s(_vm.asset.totalReceived.toLocaleString(_vm.asset.denomination)) + " "), _c('span', [_vm._v(_vm._s(_vm.asset.symbol))])]), _c('p', {
    staticClass: "utxos"
  }, [_vm._v(_vm._s(_vm.asset.utxoCount.toLocaleString()))])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }